import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.filters = this.el.querySelectorAll('[data-filter]')
    this.items = this.el.querySelectorAll('[data-filtering-item]')

    this.filters.forEach((filter) => {
      const { filter: filterName } = filter.dataset

      filter.addEventListener('click', () => {
        this.filters.forEach((f) => {
          f.classList.toggle('is-active', f.dataset.filter === filterName)
        })

        this.items.forEach((item) => {
          const { filters: itemFilters } = item.dataset

          const matchingFilter = itemFilters.includes(filterName)
          item.classList.toggle('hidden', !matchingFilter)
        })
      })
    })
  }
}
